import type { Session } from '@/api/client';
import { SESSION_READER_NOT_SET_LABEL } from '@/constants/sessionReader';
import { SessionCommentShell } from '@/features/project-cell-comments/SessionCommentShell';

type Props = {
  session: Session;
  commentCount: number;
  commentTitle: string;
  dayNum: number;
  monthName: string;
  timeStart: string;
  timeEnd: string;
  studioLabel: string;
};

export function ProjectSessionsModalCanceledRow({
  session: s,
  commentTitle,
  commentCount,
  dayNum,
  monthName,
  timeStart,
  timeEnd,
  studioLabel,
}: Props) {
  const readerLine =
    s.readers?.length ? s.readers.map((r) => r.name).join(', ') : s.reader_name?.trim() || SESSION_READER_NOT_SET_LABEL;

  return (
    <li className="project-sessions-modal__card project-sessions-modal__card_canceled project-sessions-modal__card_planned--comments-thread">
      <SessionCommentShell
        className="project-sessions-modal__session-comment-shell"
        sessionId={s.id}
        title={commentTitle}
        commentCount={commentCount}
      >
        <div className="project-sessions-modal__card-meta-row">
          <span className="project-sessions-modal__card-meta">
            <span className="project-sessions-modal__card-date project-sessions-modal__card-date_canceled">
              <strong>{dayNum}</strong> {monthName}, с {timeStart} до {timeEnd}
            </span>
            <span className="project-sessions-modal__card-studio">{studioLabel}</span>
            <span className="project-sessions-modal__card-engineer project-sessions-modal__card-engineer_canceled">
              {readerLine}
            </span>
          </span>
        </div>
      </SessionCommentShell>
    </li>
  );
}
